import PmcBridge from 'shared/services/pmc-bridge'

/**
 * Datalayer
 * @module Datalayer
 */
export default class Datalayer {
	private pmcBridge: PmcBridge
	private isUserConnected: Awaited<ReturnType<typeof PmcBridge.prototype.isConnected>>

	/**
	 * Constructor
	 */
	constructor() {
		this.pmcBridge = new PmcBridge()
		this.isUserConnected = false
	}

	/**
	 * Initialize Batch
	 */
	async init() {
		this.isUserConnected = await this.pmcBridge.isConnected()

		this.pushPaywallSubscriber()
	}

	async pushPaywallSubscriber(): Promise<void> {
		window.dataLayer.push({ paywall_subscriber: await this.paywallSubscriber() })
	}

	async paywallSubscriber(): Promise<boolean> {
		if (this.isUserConnected) {
			const subscription = await this.pmcBridge.getAllSubscriptions()

			if (subscription.includes('paid-web-content')) {
				return true
			}
		}

		return false
	}
}
